// Core
import React from 'react';

// Middlewares
import Auth from './middlewares/Auth';

// Views
import { CrusherDashboard } from './views/Equipment/Crusher/Dashboard';
import { CustomersIndex } from './views/AdminPanel/Customer/CustomersIndex';
import { EquipmentModelTable } from './views/AdminPanel/EquipmentModel/EquipmentModelTable';
import { EquipmentModelsIndex } from './views/AdminPanel/EquipmentModel';
import { Inventory } from './views/AdminPanel/Inventory/Inventory';
import { Login } from './views/Login';
import { PasswordRecovery } from './views/PasswordRecovery';
import { RegisterPassword } from './views/RegisterPassword';
import { PlantNavigation } from './views/PlantNavigation/PlantNavigation';
import { Settings } from './views/Settings/Settings';

const routes = [
  {
    path: '/',
    element: <Auth Component={CustomersIndex} Fallback={Login} />,
  },
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: 'auth/register-password',
    element: <Login />,
  },
  {
    path: 'register-password',
    element: <RegisterPassword />,
  },
  {
    path: 'password-recovery',
    element: <PasswordRecovery />,
  },
  {
    path: 'plant-management',
    element: <Auth Component={PlantNavigation} />,
  },
  // @TODO: AdminActions has no actions implemented
  // {
  //   path: 'admin-actions',
  //   element: <Auth Component={AdminActions} />,
  // },
  {
    path: '/crusher/:idEquipmentUnit',
    element: <Auth Component={CrusherDashboard} />,
  },
  {
    path: 'equipment-models',
    children: [
      {
        index: true,
        element: <EquipmentModelsIndex />,
      },
      {
        path: ':equipmentCategory',
        element: <EquipmentModelTable />,
      },
    ],
  },
  {
    path: 'inventory',
    element: <Auth Component={Inventory} />,
  },
  {
    path: 'settings/:section?',
    element: <Auth Component={Settings} />,
  },
];

export default routes;
